import React, { Component } from "react";
import {
  Col,
  Row,
  Container,
  Modal,
  Card,
  CardHeader,
  Table,
  Button
} from "reactstrap";

import { InputGroup, InputGroupText, InputGroupAddon, Input } from 'reactstrap';

import DetailedOrderCard from "../../components/DetailedOrderCard";
import RequestManager from "../../singletons/RequestManager";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CSVLink } from "react-csv";
import { SDK_CHROME } from "../../config/Constants";
import LoadingOverlay from "react-loading-overlay";
import Resonf from "./Resonf";
import AlertDialog from "./AlertDialog";
// import AlertDialog from "./AlertDialog";

export default class TrackOrderStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: [],
      orderModalVisible: false,
      focusedDate: null,
      storeInformation: null,
      startDate: moment().endOf("day"),
      endDate: moment().endOf("day"),
      bookingStartDate: moment().endOf("day"),
      bookingEndDate: moment().endOf("day"),
      pageText: "Pending Delivery",
      printSdkType: "",
      bookingDateSelected: false,
      spinnerLoading: false
    };
  }

 
  
  checkLoginMode = () => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let loginMode = localStorage.getItem("loginMode");
    if (loginMode === "merchant") {
      this.setState({
        storeInformation: storeInformation,
        pageText: "Your Order Summary"
      });
    } else {
      this.setState({ storeInformation: storeInformation });
    }
  };

  toggleModal = () => {
    this.setState({
      orderModalVisible: !this.state.orderModalVisible
    });
  };
  
  


  componentWillMount() {
    this.checkLoginMode();
  }

  componentDidMount() {
   
    this.pendingDelivery();
  }

  pendingDelivery = async () => {
    this.setState({ spinnerLoading: true });
    let requestManager = new RequestManager();
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));

    let loginMode = localStorage.getItem("loginMode");
    let params = {};
    if (loginMode === "store") {
      params = {
        storeId: storeInformation.store.id
      };
    } else if (loginMode === "merchant") {
      params = {
        merchantId: storeInformation.merchant.id
      };
    }

   
    console.log("params", params);
    let response = await requestManager.getResponseFromPredefinedQuery(
      "pendingDelivery",
      params
    );

    if (response.error === null) {
      let grandTotal = 0.0;
      for (let i = 0; i < response.data.pendingDelivery.edges.length; i++) {
        grandTotal =
          grandTotal +
          response.data.pendingDelivery.edges[i].node.cart.settlementPrice;
      }

      this.setState({
        spinnerLoading: false,
        orders: response.data.pendingDelivery.edges,
        grandTotal: grandTotal.toFixed(2)
      });
    } else {
      this.setState({ spinnerLoading: false });
    }

    console.log(response,"sa");
  };

  getCountOfItems = () => {
    if (this.state.selectedOrder) {
      let cartItems = this.state.selectedOrder.node.cart.cartItems.edges;
      let quantity = 0;
      cartItems.forEach(cartItem => {
        quantity = quantity + cartItem.node.quantity;
      });

      return quantity;
    }
  };


  render() {
    const { spinnerLoading } = this.state;
    return (
      <LoadingOverlay
        style={{ width: "100%", height: "100%", zIndex: 999 }}
        active={spinnerLoading === true ? true : false}
        spinner
        text="Loading ..."
      >
        <Container fluid style={{ padding: 0, margin: 0 }}>
          <Modal
            isOpen={this.state.orderModalVisible}
            toggle={this.toggleModal}
            size="lg"
          >
            <DetailedOrderCard
              editable={false}
              order={this.state.selectedOrder}
              toltalItemCount={null}
              goBack={this.toggleModal}
              refreshOrders={() => {}}
              pastOrder={true}
              storeInformation={this.state.storeInformation}
            />
          </Modal>

          <Row noGutters>
            <Col>
              <Card>
                <CardHeader>
                  <Container fluid>
                    <Row>
                      <Col
                        xs="12"
                        sm="12"
                        md="4"
                        lg="4"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <h5>{this.state.pageText}</h5>
                      </Col>
                
                    </Row>
              
                  </Container>
                </CardHeader>
                {/* <Resonf/> */}
                <Table responsive>
                  <tbody>
                    <tr>
                      <th>Order Id</th>
                      <th>Token</th>
                      <th>Username</th>
                      <th>Mobile</th>
                      <th>status</th>
                      <th>Date/Time</th>
                      <th>Amount</th>
                      <th>Store</th>
                      <th>Delivery Company Name</th>
                      <th>Delivery Description</th>
                      <th>Delivery Track Url</th>
                      <th>Delivery Details</th>
                    </tr>
                    {this.state.orders.map(order => {
                      return (
                        <tr
                          key={order.node.id}
                         >
                          <td>{order.node.orderId}</td>
                          <td>{order.node.storeToken}</td>
                          <td> {order.node.cart.pickupPoint.store.fetchCutomerDetails === true 
                              // && order.node.cart.checkout.payments.edges[0].node.mode === 'PREPAID_ORDER'
                                ? (order.node.tempCustomerFirstname || '') + " " + (order.node.tempCustomerLastname || '')
                                : order.node.user.userProfile.firstName + " " + order.node.user.userProfile.lastName}</td>
                          {/* <td>{order.node.user.userProfile.firstName +" "+ order.node.user.userProfile.lastName}</td> */}
                          <td> {order.node.cart.pickupPoint.store.fetchCutomerDetails === true 
                              // && order.node.cart.checkout.payments.edges[0].node.mode === 'PREPAID_ORDER'
                                ? order.node.tempCustomerPhone
                                : order.node.user.phone }</td>
                        {/* <td>{order.node.user.phone}</td> */}
                        <td>{ order.node.status}</td>
                 
                          <td>
                            {moment(order.node.createdAt).format(
                              "MMMM Do YYYY, h:mm a"
                            )}
                          </td>
                          <td>{"₹" + order.node.cart.settlementPrice}</td>
                          <td>{order.node.cart.pickupPoint.store.name}</td>

                          <td> {order.node.thirdpartyDeliverycompany} </td>
                          <td>{order.node.thirdpartyDeliverydescription} </td>
                          <td> {order.node.thirdpartyDeliveryurl} </td>
                          {order.node.cart.pickupPoint.store.thirdpartyDelivery && (
                            <td>                            
                              <td>        
                                <AlertDialog data={order}/>
                              </td>
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Card>
            </Col>
          </Row>
        </Container>
      </LoadingOverlay>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/TrackOrder/TrackOrderStatus.js